import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { HttpParams } from '@angular/common/http';
import { CurrencyPipe, formatDate } from '@angular/common';
import * as moment from 'moment';
import { TransactionsService } from './transactions.service';
import { ActivatedRoute } from '@angular/router';
import { ProductsComponent } from 'src/app/features/products/products.component';
import { FormControl } from "@angular/forms";

@Component({
  selector: 'app-transactions-history',
  templateUrl: './transactions-history.component.html',
  styleUrls: ['./transactions-history.component.scss'],
  providers: [CurrencyPipe]
})
export class TransactionsHistoryComponent extends FeaturesBaseComponent implements OnInit {
  private allTransactionSummary;
  private allTransactions;

  private retailerId;
  public retailerdata;

  private startDate;
  private endDate;

  public rowData;
  public columnDefs;

  transactionSummary: any;
  salesSummary: any;
  commissionSummary: any;
  dilyTransactionsCount: any;
  weeklyTransactionsCount: any;
  allTransactionsCount: any;
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  monthlySaleSummary: any;
  monthlyCommisionSummary: any;
  monthlyTransactionsCount: any;
  searchValue: any;
  minFromDate: Date;
  maxDate: Date = new Date();
  minToDate: Date;
  transactionStartDate: string;
  transactionEndDate: string;
  commissionSummaryData: any[];
  saleSummaryData: any[];
  promocodeSummary: any;
  fromCntrl = new FormControl();
  toCntrl = new FormControl();
  retailerUserName: any;
  retailerAccountNum: any;
  currentAmount: any;
  showCard: boolean = true;

  constructor(private transactionService: TransactionsService, private currencyPipe: CurrencyPipe, private activeRoute: ActivatedRoute) {
    super();

  }

  /* Map sales summary values */
  setSummaryValues(allTransactionSummary: any) {
    this.transactionSummary = allTransactionSummary.transactionSummary;
    this.dilyTransactionsCount = allTransactionSummary.dailyTransactionSummary;
    this.weeklyTransactionsCount = allTransactionSummary.weeklyTransactionSummary;
    this.monthlyTransactionsCount = allTransactionSummary.monthlyTransactionSummary;
    this.allTransactionsCount = allTransactionSummary.allTransactionSummary;
    this.salesSummary = allTransactionSummary.salesSummary;
    this.monthlySaleSummary = allTransactionSummary.monthlySalesSummary;
    this.commissionSummary = allTransactionSummary.commissionSummary;
    this.promocodeSummary = allTransactionSummary.promocodeSummary;
    this.monthlyCommisionSummary = allTransactionSummary.monthlyCommissionSummary;
    let _salesSummary: any = (this.salesSummary / this.monthlySaleSummary) * 100;
    this.saleSummaryData = [_salesSummary, 100 - _salesSummary];
    let _commissionSummary: any = (this.commissionSummary / this.monthlyCommisionSummary) * 100;
    this.commissionSummaryData = [_commissionSummary, 100 - _commissionSummary];
  }

  setRowData(rowData: any) {
    this.rowData = rowData;
  }

  /**
   * Get curretnt retailer details from the route params id
   */
  getretailerDetails() {
    this.retailerId = this.activeRoute.snapshot.params.retailerId;
    this.transactionService.getSelectedRetailer(this.retailerId).subscribe(
      res => this.retailerdata = res['httpcode'] == 200 ? res['data'] : []);
  }

  handleApprove(rowData) {
    if (rowData.amount < 0 || (rowData.refundStatus?.toLowerCase() == "yes")) {
      return
    }
    //alert
    //;
    if (rowData.beneficiaryNumber && rowData.beneficiaryNumber) {
      let formData: any = {
        beneficiaryNumber: rowData.beneficiaryNumber,
        productType: rowData.productType,
        rechargeAmount: rowData.amount,
        requestId: rowData.requestId,
      };
      this.transactionService.approvePinlessrefund(formData).subscribe((res) => {
        if (res["httpcode"] == 200) {
          this.toastrService.success(`Refund Successful!`, `Success`);
          let params: any = new HttpParams()
            .set("startDate", this.startDate)
            .set("endDate", this.endDate)
            .set("retailerId", this.retailerId);
          this.transactionService.getAllTransactions(params).subscribe((res) => {
            let resData: any = res;
            if (resData.httpcode == 200) {
              resData = resData.data;
              this.setRowData(res["data"]);
              //this.realtime = resData;
            }
          });
        }

      });

    }
  }

  /* ----- On Export click -----*/
  exportData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: 'Transactions-History.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      // 
      if (cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      } else if (cellParams && cellParams.column.colId === 'date') {
        return moment(cellParams.value).format('MM/DD/YYYY')
      } else if (cellParams && cellParams.column.colId === 'amount' || cellParams.column.colId === 'commission' || cellParams.column.colId === 'initialBalance' || cellParams.column.colId === 'endingBalance') {
        return this.currencyPipe.transform(cellParams.value)
      } else if(cellParams && cellParams.column.colId === 'time') {
        return moment(cellParams.value).format("hh:mm:ss a")
      }
      else return cellParams.value // no formatting
    }
    this.gridApi.exportDataAsCsv(params);
  }

  /* ------ AG Grid Events ------*/
  /* On Grid Ready */
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  /* On Global Search input changes */
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }
  /* On Row Selection Change */
  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();
  }

  /* ----- End of AG Grid Events -----*/


  /*  ----- Calendar click events ----- */

  onClickMonth() {
    let date = new Date();
    let startOfMonth = moment().startOf('month').toDate();
    this.fromCntrl.setValue(startOfMonth);
    this.toCntrl.setValue(new Date(date.getFullYear(), date.getMonth() + 1, 0));
    this.transactionStartDate = this.fromCntrl.value;
    this.transactionEndDate = this.toCntrl.value;
    console.log(this.transactionStartDate)
    console.log(this.transactionStartDate)
    this.getTransactionHistory();
    // this.changeToDate(e);
  }

  onClickYear() {
    let date = new Date();
    let startOfYear = moment().startOf('year').toDate();
    console.log(startOfYear);
    this.fromCntrl.setValue(startOfYear);
    this.toCntrl.setValue(new Date(date.getFullYear(),11, 31));
    this.transactionStartDate = this.fromCntrl.value;
    this.transactionEndDate = this.toCntrl.value;
    this.getTransactionHistory();
  }


  getTransactionHistory() {
    let from = formatDate(this.fromCntrl.value, "yyyy-MM-dd", "en");
    let to = formatDate(this.toCntrl.value, "yyyy-MM-dd", "en");
    let retailerId = this.activeRoute.snapshot.params.retailerId;
    let params: any = new HttpParams().set('retailerId', retailerId).set('startDate', from).set('endDate', to)
    this.transactionService.getAllTransactions(params)
      .subscribe((res) => {
        if (res["httpcode"] == 200 && res["data"] != null) {
          this.setRowData(res["data"]);
          this.transactionService.getAllTransactionSummary(params)
            .subscribe((res) => {
              if (res["httpcode"] == 200) {
                this.allTransactionSummary = res["data"];
                this.setSummaryValues(this.allTransactionSummary);
              }
            });
        }
      });
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.transactionStartDate = formatDate(e.value, 'yyyy-MM-dd', 'en');
    this.transactionEndDate = formatDate(this.toCntrl.value, 'yyyy-MM-dd', 'en');
    if (this.transactionStartDate != null && this.transactionStartDate != undefined) {
      let retailerId = this.activeRoute.snapshot.params.retailerId;
      let params: any = new HttpParams().set('retailerId', retailerId).set('startDate', this.transactionStartDate).set('endDate', this.transactionEndDate)
      this.transactionService.getAllTransactions(params).subscribe(
        res => {
          if (res['httpcode'] == 200 && res['data'] != null) {
            this.setRowData(res['data']);
            this.transactionService.getAllTransactionSummary(params)
              .subscribe((res) => {
                if (res["httpcode"] == 200) {
                  this.allTransactionSummary = res["data"];
                  this.setSummaryValues(this.allTransactionSummary);
                }
              });
          }
        }
      );
    }
  }

  changeToDate(e) {
    this.transactionStartDate = formatDate(this.fromCntrl.value, 'yyyy-MM-dd', 'en');
    this.transactionEndDate = formatDate(e.value, 'yyyy-MM-dd', 'en');
    if (this.transactionStartDate != null && this.transactionStartDate != undefined) {
      let retailerId = this.activeRoute.snapshot.params.retailerId;
      let params: any = new HttpParams().set('retailerId', retailerId).set('startDate', this.transactionStartDate).set('endDate', this.transactionEndDate)
      this.transactionService.getAllTransactions(params).subscribe(
        res => {
          if (res['httpcode'] == 200 && res['data'] != null) {
            this.setRowData(res['data']);
            this.transactionService.getAllTransactionSummary(params)
              .subscribe((res) => {
                if (res["httpcode"] == 200) {
                  this.allTransactionSummary = res["data"];
                  this.setSummaryValues(this.allTransactionSummary);
                }
              });
          }
        }
      );
    }
  }

  /*  ----- End of Calendar click events ----- */



  /*  Lifecycle methods */

  /* OnInit */
  ngOnInit(): void {
    const self = this;
    super.ngOnInit();

    this.fromCntrl.setValue(new Date());
    this.toCntrl.setValue(new Date());

    this.getretailerDetails();
    this.getTransactionHistory();

    this.transactionStartDate = formatDate(this.fromCntrl.value, 'yyyy-MM-dd', 'en');
    this.transactionEndDate = formatDate(this.toCntrl.value, 'yyyy-MM-dd', 'en');

    this.columnDefs = [
      // { field: 'null', headerName: 'Action', width: 110, checkboxSelection: true },
      {
        field: 'date', headerName: 'Date', width: 150, sort: "desc", cellRenderer: (data) => {
          return moment(data.value).format('MM/DD/YYYY')
        }
      },
      {
        field: 'time', headerName: 'Time', width: 150, cellRenderer: (data) => {
          return moment(data.value).format('hh:mm:ss:a')
        }
      },
      { field: 'productName', headerName: 'Product', width: 200 },
      {
        field: 'amount', headerName: 'Amount', width: 150, cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value)
        }
      },
      {
        field: 'commission', headerName: 'Commission', width: 180, cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value)
        }
      },
      {
        field: 'promoCodeAmt', headerName: 'Promocode Amount', width: 250, cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value)
        }
      },
      { field: 'beneficiaryNumber', headerName: 'Beneficiary Number', width: 270 },
      { field: 'confirmationNumber', headerName: 'Confirmation Number', width: 250 },
      {
        field: 'initialBalance', headerName: 'Initial Balance', width: 200, cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value)
        }
      },
      {
        field: 'endingBalance', headerName: 'Ending Balance', width: 200, cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value)
        }
      },

      { field: 'transactionType', headerName: 'Transaction Type', width: 230 },
      { field: 'userName', headerName: 'User Name', width: 180 },
      {
        field: 'codeGroup', headerName: 'Code Group', width: 240,
        cellRenderer: (params) => {
          if (params.value.toLowerCase() === "pinless" && params.data.amount > 0) {
            if (params.data.refundStatus == null || params.data.refundStatus?.toLowerCase() != "yes") {
              return `${params.value}  &nbsp;<span class="rounded-pill bg-main text-white px-2 py-1 cur-point">Refund</span>`
            }

            if (params.data.refundStatus != null && params.data.refundStatus?.toLowerCase() == "yes") {
              return `${params.value}  &nbsp;<span class="rounded-pill bg-light text-main px-2 py-1">Refunded</span>`
            }
          }
          return params.value;
        },
        onCellClicked: function (params) {
          if (params.value == "PINLESS") {
            self.handleApprove(params.data);
          }
        },
      },
      //Products
      { field: 'carrier', headerName: 'Carrier', width: 200 },
      { field: 'paymentType', headerName: 'Payment Type', width: 210 },
      { field: 'confirmationMessage', headerName: 'Confirmation Message', width: 280 },
    ]
    this.rowData = [];
  }

  /* OnDestroy */
  ngOnDestroy(): void {
    super.ngOnDestroy()
  }

}
